import {Space} from "antd";
import {FireOutlined} from "@ant-design/icons";

function VerificationPending() {

    return (
        <div className={"flex mt-6"}>
            <div className={"mx-auto text-center"} style={{maxWidth: 600}}>
                <Space direction={"vertical"} align={"center"}>
                    <FireOutlined style={{fontSize: 32}}/>
                    <div>
                        <h4>{"Your verification is currently under review."}</h4>
                        <p>We’ll notify you as soon as the process is complete.</p>
                    </div>
                </Space>
            </div>
        </div>
    )
}

export default VerificationPending;
